var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    width: 130,
    height: 130,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path 0",
    className: "shp0",
    d: "M42,0h7v17h-7v-8.5M62,0h6v17h-6v-8.5M81,0h7v17h-7v-8.5M65,23c36.67,0 38.07,0.07 40,2c1.93,1.93 2,3.33 2,40c0,36.67 -0.07,38.07 -2,40c-1.93,1.93 -3.33,2 -40,2c-36.67,0 -38.07,-0.07 -40,-2c-1.93,-1.93 -2,-3.33 -2,-40c0,-36.67 0.07,-38.07 2,-40c1.93,-1.93 3.33,-2 40,-2zM42.78,64.95c0.13,14.24 0.53,19.89 1.45,20.82c0.94,0.94 6.35,1.26 20.82,1.25c14.31,-0.01 19.88,-0.35 20.77,-1.27c0.87,-0.9 1.22,-6.79 1.22,-20.75c0,-14.4 -0.33,-19.83 -1.27,-20.77c-0.94,-0.94 -6.35,-1.26 -20.82,-1.25c-13.74,0.01 -19.97,0.37 -20.95,1.22c-1.12,0.96 -1.36,5.06 -1.22,20.75zM0,42h17v7h-17v-3.5M113,42h17v7h-17v-3.5M0,62h17v6h-17v-3M113,62h17v6h-17v-3M0,81h17v7h-17v-3.5M113,81h17v7h-17v-3.5M42,113h7v17h-7v-8.5M62,113h6v17h-6v-8.5M81,113h7v17h-7v-8.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.e31e7f4feae781825c6845e8630796cf.svg";
export { ForwardRef as ReactComponent };